import FormSari from "../../../../content/posts/data/social-attitudes-research-india-sari-data/FormSari.js";
import * as React from 'react';
export default {
  FormSari,
  React
};